
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("cm2rU", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable no-restricted-imports */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $c6GJD = parcelRequire("c6GJD");


var $i7jPX = parcelRequire("i7jPX");





var $inPa6 = parcelRequire("inPa6");

const $8a854455b1a7ea24$export$a4c96b4ef1bf8976 = 'optout_all_messages';
const $8a854455b1a7ea24$export$f64870f8abb59f0b = 'optout_all_messages_user';
const $8a854455b1a7ea24$export$48e1d3fa57b0a2d5 = 'optoutAllMessages';
const $8a854455b1a7ea24$export$5ede056addcc7dcf = `${$8a854455b1a7ea24$export$48e1d3fa57b0a2d5}.fetchSiteOptout succeeded`;
const $8a854455b1a7ea24$export$a16c0f38ba8f83e8 = `${$8a854455b1a7ea24$export$48e1d3fa57b0a2d5}.fetchSiteOptout failed`;
const $8a854455b1a7ea24$export$2b6f8d7fd154b638 = `${$8a854455b1a7ea24$export$48e1d3fa57b0a2d5}.fetchSiteUserOptout succeeded`;
const $8a854455b1a7ea24$export$74a38b22acdaeea2 = `${$8a854455b1a7ea24$export$48e1d3fa57b0a2d5}.fetchSiteUserOptout failed`;
const $8a854455b1a7ea24$export$85183a312807388d = 'postOffice';
const $8a854455b1a7ea24$export$947dac6c72b26f81 = 'track';
const $8a854455b1a7ea24$export$338a9c38f183f620 = 100; // 0.1 second


const $db3d188af07fd475$var$getTraceId = (response)=>{
    const traceIdHeader = [
        'atl-traceid',
        'x-trace-id'
    ].find((header)=>response.headers?.has(header));
    return traceIdHeader === undefined ? undefined : response.headers.get(traceIdHeader) ?? undefined;
};
class $db3d188af07fd475$var$FetchError extends Error {
    constructor(statusCode, message, traceId, originalResponse){
        super(message || `Fetch call failed with status code: ${statusCode}`);
        this.skipSentry = void 0;
        this.statusCode = void 0;
        this.traceId = void 0;
        this.originalResponse = void 0;
        this.name = 'FetchError';
        this.statusCode = statusCode;
        this.originalResponse = originalResponse;
        this.skipSentry = statusCode === 401;
        if (traceId) this.traceId = traceId;
    }
}
const $db3d188af07fd475$var$getDevHostname = ()=>{
    const envDns = undefined;
    return typeof envDns === 'string' && envDns.trim() ? envDns.trim() : 'localhost';
};
const $db3d188af07fd475$var$getProxyServerPort = ()=>{
    return 9000;
};
const $db3d188af07fd475$var$LOCAL_URL = new URL(`${'http'}://${$db3d188af07fd475$var$getDevHostname()}:${$db3d188af07fd475$var$getProxyServerPort()}`);
const $db3d188af07fd475$var$getReroutableURL = (pathOrURL)=>{
    var e;
    return pathOrURL;
};
const $db3d188af07fd475$var$defaultOptions = {
    credentials: 'same-origin',
    headers: {
        'Content-Type': 'application/json',
        Accept: [
            'application/json',
            'text/javascript',
            '*/*'
        ]
    }
};
let $db3d188af07fd475$var$cachedFetches = {};
let $db3d188af07fd475$var$siteOptoutStatuses = {};
let $db3d188af07fd475$var$siteUserOptoutStatuses = {};
let $db3d188af07fd475$var$firedAnalyticsEvents = {};
let $db3d188af07fd475$var$isAnalyticsDebounceEnabled = true;
const $db3d188af07fd475$export$d2adf65b87e47523 = ()=>{
    $db3d188af07fd475$var$siteOptoutStatuses = {};
    $db3d188af07fd475$var$siteUserOptoutStatuses = {};
    $db3d188af07fd475$var$cachedFetches = {};
};
const $db3d188af07fd475$var$clearFetchCacheForUrl = (url)=>{
    delete $db3d188af07fd475$var$cachedFetches[url];
};
const $db3d188af07fd475$var$fetchJsonWithCache = (url, options = {})=>{
    let fetchPromise = $db3d188af07fd475$var$cachedFetches[url];
    if (fetchPromise) return fetchPromise;
    fetchPromise = fetch($db3d188af07fd475$var$getReroutableURL(url), {
        ...$db3d188af07fd475$var$defaultOptions,
        ...options
    });
    $db3d188af07fd475$var$cachedFetches[url] = fetchPromise;
    return fetchPromise;
};
const $db3d188af07fd475$var$fetchJson = (url, options = {})=>$db3d188af07fd475$var$fetchJsonWithCache(url, options).then((response)=>{
        if (!response.ok) {
            const traceId = $db3d188af07fd475$var$getTraceId(response);
            if (traceId !== undefined && traceId.length > 0) throw new $db3d188af07fd475$var$FetchError(response.status, `Fetch call failed with status code: ${response.status}`, traceId, response);
            else throw new $db3d188af07fd475$var$FetchError(response.status, undefined, undefined, response);
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return response.clone().json();
    });
const $db3d188af07fd475$var$getPersonalizationSiteTraitsUrl = (cloudId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`;
const $db3d188af07fd475$var$getPersonalizationSiteUserTraitsUrl = (cloudId, userId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`;
const $db3d188af07fd475$var$parseOptoutTraitStatus = (attributes, attributeName)=>{
    const optoutValue = attributes.find(({ name: name })=>name === attributeName)?.value;
    return optoutValue ? 'is-opted-out' : 'no-opt-out';
};
const $db3d188af07fd475$var$parseSiteOptoutTraitStatus = (attributes)=>{
    return $db3d188af07fd475$var$parseOptoutTraitStatus(attributes, (0, $8a854455b1a7ea24$export$a4c96b4ef1bf8976));
};
const $db3d188af07fd475$var$parseSiteUserOptoutTraitStatus = (attributes)=>{
    return $db3d188af07fd475$var$parseOptoutTraitStatus(attributes, (0, $8a854455b1a7ea24$export$f64870f8abb59f0b));
};
const $db3d188af07fd475$var$fetchSiteTraitData = async (cloudId)=>{
    if (Boolean($db3d188af07fd475$var$siteOptoutStatuses[cloudId]) && ($db3d188af07fd475$var$siteOptoutStatuses[cloudId] === 'is-opted-out' || $db3d188af07fd475$var$siteOptoutStatuses[cloudId] === 'no-opt-out')) return {
        optoutStatus: $db3d188af07fd475$var$siteOptoutStatuses[cloudId],
        cached: true
    };
    try {
        const url = $db3d188af07fd475$var$getPersonalizationSiteTraitsUrl(cloudId);
        if ($db3d188af07fd475$var$siteOptoutStatuses[cloudId] === 'error') $db3d188af07fd475$var$clearFetchCacheForUrl(url);
        const { attributes: attributes } = await $db3d188af07fd475$var$fetchJson(url, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'x-atlassian-mau-ignore': 'true'
            }
        });
        $db3d188af07fd475$var$siteOptoutStatuses[cloudId] = $db3d188af07fd475$var$parseSiteOptoutTraitStatus(attributes);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching site personalization:', error);
        $db3d188af07fd475$var$siteOptoutStatuses[cloudId] = 'error';
        throw error;
    }
    return {
        optoutStatus: $db3d188af07fd475$var$siteOptoutStatuses[cloudId],
        cached: false
    };
};
const $db3d188af07fd475$var$fetchSiteUserTraitData = async (cloudId, userId)=>{
    if (Boolean($db3d188af07fd475$var$siteUserOptoutStatuses[cloudId]?.[userId]) && ($db3d188af07fd475$var$siteUserOptoutStatuses[cloudId]?.[userId] === 'is-opted-out' || $db3d188af07fd475$var$siteUserOptoutStatuses[cloudId]?.[userId] === 'no-opt-out')) return {
        optoutStatus: $db3d188af07fd475$var$siteUserOptoutStatuses[cloudId]?.[userId],
        cached: true
    };
    try {
        const url = $db3d188af07fd475$var$getPersonalizationSiteUserTraitsUrl(cloudId, userId);
        if ($db3d188af07fd475$var$siteUserOptoutStatuses[cloudId]?.[userId] === 'error') $db3d188af07fd475$var$clearFetchCacheForUrl(url);
        const { attributes: attributes } = await $db3d188af07fd475$var$fetchJson(url, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'x-atlassian-mau-ignore': 'true'
            }
        });
        $db3d188af07fd475$var$siteUserOptoutStatuses[cloudId] = {
            ...$db3d188af07fd475$var$siteUserOptoutStatuses[cloudId] ?? {},
            [userId]: $db3d188af07fd475$var$parseSiteUserOptoutTraitStatus(attributes)
        };
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching site user personalization:', error);
        $db3d188af07fd475$var$siteUserOptoutStatuses[cloudId] = {
            ...$db3d188af07fd475$var$siteUserOptoutStatuses[cloudId] ?? {},
            [userId]: 'error'
        };
        throw error;
    }
    return {
        optoutStatus: $db3d188af07fd475$var$siteUserOptoutStatuses[cloudId][userId],
        cached: false
    };
};
/**
 * | Site / Site user | initial      | is-opted-out | no-opt-out   | error        |
 * |------------------|--------------|--------------|--------------|--------------|
 * | initial          | initial      | is-opted-out | initial      | initial      |
 * | is-opted-out     | is-opted-out | is-opted-out | is-opted-out | is-opted-out |
 * | no-opt-out       | initial      | is-opted-out | no-opt-out   | error        |
 * | error            | initial      | is-opted-out | error        | error        |
 * @param siteOptoutValue
 * @param siteUserOptoutValue
 */ const $db3d188af07fd475$var$combineOptoutValue = (siteOptoutValue, siteUserOptoutValue)=>{
    const matrix = {
        initial: {
            initial: 'initial',
            'is-opted-out': 'is-opted-out',
            'no-opt-out': 'initial',
            error: 'initial'
        },
        'is-opted-out': {
            initial: 'is-opted-out',
            'is-opted-out': 'is-opted-out',
            'no-opt-out': 'is-opted-out',
            error: 'is-opted-out'
        },
        'no-opt-out': {
            initial: 'initial',
            'is-opted-out': 'is-opted-out',
            'no-opt-out': 'no-opt-out',
            error: 'error'
        },
        error: {
            initial: 'initial',
            'is-opted-out': 'is-opted-out',
            'no-opt-out': 'error',
            error: 'error'
        }
    };
    return matrix[siteOptoutValue][siteUserOptoutValue] || 'initial';
};
const $db3d188af07fd475$export$433d05f24f06f81a = (enabled)=>{
    $db3d188af07fd475$var$isAnalyticsDebounceEnabled = enabled;
};
const $db3d188af07fd475$var$isAnalyticsEventFiredWithinDebounceWindow = (eventName, touchpointId)=>{
    const currentTime = Date.now();
    const lastFiredTime = $db3d188af07fd475$var$firedAnalyticsEvents[eventName]?.[touchpointId] ?? 0;
    if (currentTime - lastFiredTime < (0, $8a854455b1a7ea24$export$338a9c38f183f620)) return true;
    $db3d188af07fd475$var$firedAnalyticsEvents[eventName] = {
        ...$db3d188af07fd475$var$firedAnalyticsEvents[eventName] ?? {},
        [touchpointId]: currentTime
    };
    return false;
};
const $db3d188af07fd475$var$fireTrackAnalytics = (analyticsEvent, eventName, attributes)=>{
    if ($db3d188af07fd475$var$isAnalyticsDebounceEnabled && attributes.touchpointId && $db3d188af07fd475$var$isAnalyticsEventFiredWithinDebounceWindow(eventName, attributes.touchpointId)) return;
    const clonedEvent = analyticsEvent.clone();
    if (clonedEvent) {
        const [actionSubject, action] = eventName.split(' ');
        clonedEvent.update({
            eventType: (0, $8a854455b1a7ea24$export$947dac6c72b26f81),
            actionSubject: actionSubject,
            action: action,
            attributes: {
                ...clonedEvent.payload?.attributes ?? {},
                ...attributes ?? {}
            }
        });
        clonedEvent.fire((0, $8a854455b1a7ea24$export$85183a312807388d));
    }
};
const $db3d188af07fd475$export$9af97c6b33df5bae = async (touchpointId, cloudId, analyticsEvent, options)=>{
    let optoutStatus = 'initial';
    try {
        const fetchResult = await $db3d188af07fd475$var$fetchSiteTraitData(cloudId);
        optoutStatus = fetchResult.optoutStatus;
        if (analyticsEvent) $db3d188af07fd475$var$fireTrackAnalytics(analyticsEvent, (0, $8a854455b1a7ea24$export$5ede056addcc7dcf), {
            cloudId: cloudId,
            touchpointId: touchpointId,
            optoutStatus: optoutStatus,
            cached: fetchResult.cached
        });
    } catch (error) {
        if (analyticsEvent) $db3d188af07fd475$var$fireTrackAnalytics(analyticsEvent, (0, $8a854455b1a7ea24$export$a16c0f38ba8f83e8), {
            error: error instanceof $db3d188af07fd475$var$FetchError ? error.message : 'Unknown error',
            traceId: error instanceof $db3d188af07fd475$var$FetchError ? error.traceId : undefined,
            cloudId: cloudId,
            touchpointId: touchpointId,
            optoutStatus: optoutStatus
        });
        options?.onError?.(error);
        return {
            optoutStatus: 'error'
        };
    }
    return {
        optoutStatus: optoutStatus
    };
};
const $db3d188af07fd475$export$a9e7c50f402a03d2 = async (touchpointId, cloudId, userId, analyticsEvent, options)=>{
    let optoutStatus = 'initial';
    try {
        const fetchResult = await $db3d188af07fd475$var$fetchSiteUserTraitData(cloudId, userId);
        optoutStatus = fetchResult.optoutStatus;
        if (analyticsEvent) $db3d188af07fd475$var$fireTrackAnalytics(analyticsEvent, (0, $8a854455b1a7ea24$export$2b6f8d7fd154b638), {
            cloudId: cloudId,
            userId: userId,
            touchpointId: touchpointId,
            optoutStatus: optoutStatus,
            cached: fetchResult.cached
        });
    } catch (error) {
        if (analyticsEvent) $db3d188af07fd475$var$fireTrackAnalytics(analyticsEvent, (0, $8a854455b1a7ea24$export$74a38b22acdaeea2), {
            error: error instanceof $db3d188af07fd475$var$FetchError ? error.message : 'Unknown error',
            traceId: error instanceof $db3d188af07fd475$var$FetchError ? error.traceId : undefined,
            cloudId: cloudId,
            userId: userId,
            touchpointId: touchpointId,
            optoutStatus: optoutStatus
        });
        options?.onError?.(error);
        return {
            optoutStatus: 'error'
        };
    }
    return {
        optoutStatus: optoutStatus
    };
};
const $db3d188af07fd475$export$aa440d3a24a2d79a = async (touchpointId, cloudId, userId, analyticsEvent, options)=>{
    if (userId) {
        const [siteOptoutPayload, siteUserOptoutPayload] = await Promise.all([
            $db3d188af07fd475$export$9af97c6b33df5bae(touchpointId, cloudId, analyticsEvent, options),
            $db3d188af07fd475$export$a9e7c50f402a03d2(touchpointId, cloudId, userId, analyticsEvent, options)
        ]);
        try {
            return {
                optoutStatus: $db3d188af07fd475$var$combineOptoutValue(siteOptoutPayload.optoutStatus, siteUserOptoutPayload.optoutStatus)
            };
        } catch (error) {
            options?.onError?.(error);
            return {
                optoutStatus: 'error'
            };
        }
    }
    return $db3d188af07fd475$export$9af97c6b33df5bae(touchpointId, cloudId, analyticsEvent, options);
};
const $db3d188af07fd475$export$ef6308b7e747ceec = (touchpointId, cloudId, options)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [optoutStatus, setOptoutStatus] = (0, $42omo.useState)('initial');
    const isDisabled = options?.isDisabled ?? false;
    const onError = options?.onError ?? null;
    (0, $42omo.useEffect)(()=>{
        if (!isDisabled) $db3d188af07fd475$export$9af97c6b33df5bae(touchpointId, cloudId, createAnalyticsEvent({}), {
            onError: onError
        }).then(({ optoutStatus: status })=>{
            setOptoutStatus(status);
        });
    }, [
        cloudId,
        isDisabled,
        touchpointId,
        createAnalyticsEvent,
        onError
    ]);
    return {
        optoutStatus: optoutStatus
    };
};
const $db3d188af07fd475$export$e5b57ebc3eed2ecb = (touchpointId, cloudId, userId, options)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [optoutStatus, setOptoutStatus] = (0, $42omo.useState)('initial');
    const isDisabled = options?.isDisabled ?? false;
    const onError = options?.onError ?? null;
    (0, $42omo.useEffect)(()=>{
        if (!isDisabled) $db3d188af07fd475$export$a9e7c50f402a03d2(touchpointId, cloudId, userId, createAnalyticsEvent({}), {
            onError: onError
        }).then(({ optoutStatus: status })=>{
            setOptoutStatus(status);
        });
    }, [
        cloudId,
        userId,
        isDisabled,
        touchpointId,
        createAnalyticsEvent,
        onError
    ]);
    return {
        optoutStatus: optoutStatus
    };
};
const $db3d188af07fd475$export$7d4c6b519725ba3b = (touchpointId, cloudId, userId, options)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [optoutStatus, setOptoutStatus] = (0, $42omo.useState)('initial');
    const isDisabled = options?.isDisabled ?? false;
    const onError = options?.onError ?? null;
    (0, $42omo.useEffect)(()=>{
        if (!isDisabled) $db3d188af07fd475$export$aa440d3a24a2d79a(touchpointId, cloudId, userId, createAnalyticsEvent({}), {
            onError: onError
        }).then(({ optoutStatus: status })=>{
            setOptoutStatus(status);
        }).catch((error)=>{
            onError?.(error);
        });
    }, [
        cloudId,
        userId,
        isDisabled,
        touchpointId,
        createAnalyticsEvent,
        onError
    ]);
    return {
        optoutStatus: optoutStatus
    };
};



var $PAiZW = parcelRequire("PAiZW");


var $lfQiY = parcelRequire("lfQiY");


var $fJvXe = parcelRequire("fJvXe");

var $hRQgD = parcelRequire("hRQgD");

var $6FJLn = parcelRequire("6FJLn");


var $9irGW = parcelRequire("9irGW");


var $2YerA = parcelRequire("2YerA");


var $7XIdu = parcelRequire("7XIdu");


var $4nMma = parcelRequire("4nMma");


var $2mPpz = parcelRequire("2mPpz");


var $6Ht9d = parcelRequire("6Ht9d");


var $gtD4K = parcelRequire("gtD4K");





var $aD1SW = parcelRequire("aD1SW");

var $6uGcC = parcelRequire("6uGcC");


var $3sFtD = parcelRequire("3sFtD");


var $6fnsQ = parcelRequire("6fnsQ");













/* wac-toast.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $hmuev = parcelRequire("hmuev");


var $8C5kA = parcelRequire("8C5kA");

const $990856b2b017a9e4$var$mainContainerStyle = null;
const $990856b2b017a9e4$var$closedToastStyle = null;
const $990856b2b017a9e4$var$contentSectionStyle = null;
const $990856b2b017a9e4$var$imageSectionStyle = null;
const $990856b2b017a9e4$var$showToastAnimationStyle = null;
const $990856b2b017a9e4$var$titleStyle = null;
const $990856b2b017a9e4$var$descriptionStyle = null;
const $990856b2b017a9e4$var$closePanelIconContainerStyle = null;
const $990856b2b017a9e4$export$df43802f8a343160 = (props)=>{
    const { title: title, description: description, onDismissed: onDismissed } = props;
    const [shouldAnimate, setShouldAnimate] = (0, $42omo.useState)(false);
    const [isClosed, setIsClosed] = (0, $42omo.useState)(false);
    const intl = (0, $8C5kA.default)();
    const dismissToastAriaLabel = intl.formatMessage({
        id: "growth.app-switcher-discovery-section.wac-toast.close.aria-label",
        defaultMessage: "Dismiss toast"
    });
    (0, $42omo.useEffect)(()=>{
        setTimeout(()=>{
            setShouldAnimate(true);
        }, 100);
    }, []);
    (0, $42omo.useEffect)(()=>{
        // auto dismiss
        setTimeout(()=>{
            closeToastCard();
        }, 8000);
    }, []);
    const closeToastCard = ()=>{
        setIsClosed(true);
    };
    const handleOnCloseClick = ()=>{
        closeToastCard();
        setTimeout(()=>{
            onDismissed && onDismissed();
        }, 800);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            "_2rko12b0 _tzy4idpf _16qs1nta _1bsb1178 _bfhkvuon _t9ec1pmk _1qza1osq _1mrf17un",
            shouldAnimate && "_v56413jc _tzy4kb7n _t9ec1kli _1mrfvg6r",
            isClosed && "_v564wlka _tzy4idpf _t9ec1o0r _1qza1osq _1mrf1jum"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)("div", {
            className: (0, $gMc0m.default)([
                "_2rko12b0 _1yt41ejb _1e0c1txw _2lx21bp4 _bfhkvuon _y3gn1e5h"
            ]),
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                    className: (0, $gMc0m.default)([
                        "_1e0c1txw _2lx2vrvc _1bah1yb4"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)($990856b2b017a9e4$var$SuccessIcon, {}),
                        /*#__PURE__*/ (0, $l998X.jsx)("button", {
                            id: "toast-close-button",
                            onClick: handleOnCloseClick,
                            "aria-label": dismissToastAriaLabel,
                            className: (0, $gMc0m.default)([
                                "_bfhk1j28 _19itidpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _80omtlke _1e0c1txw _4cvr1h6o"
                            ]),
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                                label: dismissToastAriaLabel,
                                size: "small"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("h3", {
                    className: (0, $gMc0m.default)([
                        "_k48p1nn1 _vwz43ei5 _ect41kw7 _1wyb1k8s _19pkpxbi _otyru2gc"
                    ]),
                    children: title
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("p", {
                    className: (0, $gMc0m.default)([
                        "_18s81bpf"
                    ]),
                    children: description
                })
            ]
        })
    });
};
const $990856b2b017a9e4$var$SuccessIcon = ()=>/*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M20 0C8.95431 0 0 8.95431 0 20C0 31.0457 8.95431 40 20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0ZM27.8668 16.2282C28.4316 15.6086 28.4144 14.648 27.8154 14.049L27.7617 13.9977C27.142 13.4329 26.1815 13.45 25.5825 14.049L17.2709 22.3606L14.4176 19.5074L14.3639 19.4561C13.7442 18.8913 12.7837 18.9084 12.1847 19.5074C11.568 20.124 11.568 21.1237 12.1847 21.7404L16.1544 25.7101L16.2082 25.7614C16.8278 26.3262 17.7883 26.3091 18.3873 25.7101L27.8154 16.282L27.8668 16.2282Z",
            fill: "#82B536"
        })
    });


const $8d3e387dfec25223$export$f9a3c275d8ffdac0 = (messageId)=>(currentMessageIds)=>currentMessageIds.filter((id)=>id !== messageId);


// /**--Title--**/
const $75181cea81fbaddd$var$Title = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
        id: "growth.app-switcher-discovery-section.flag.title",
        defaultMessage: "Got it, thanks for letting us know"
    });
// /**--Description--**/
const $75181cea81fbaddd$var$Description = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
        id: "growth.app-switcher-discovery-section.flag.description",
        defaultMessage: "You won\u2019t see this here as often."
    });
const $75181cea81fbaddd$export$a309243da00b18dc = ({ dismissedMessageIds: dismissedMessageIds, handleDismissFlag: handleDismissFlag })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    const isInWacContext = (0, $4nMma.useIsWacContext)();
    const onDismissed = (messageId)=>{
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'adControlsFlagClose'
        });
        handleDismissFlag(messageId);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6uGcC.default), {
        children: dismissedMessageIds.map((messageId)=>isInWacContext ? /*#__PURE__*/ (0, $l998X.jsx)((0, $990856b2b017a9e4$export$df43802f8a343160), {
                title: /*#__PURE__*/ (0, $l998X.jsx)($75181cea81fbaddd$var$Title, {}),
                description: /*#__PURE__*/ (0, $l998X.jsx)($75181cea81fbaddd$var$Description, {}),
                onDismissed: ()=>onDismissed(messageId)
            }, messageId) : /*#__PURE__*/ (0, $l998X.jsx)((0, $aD1SW.default), {
                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
                    spacing: "spacious",
                    color: `var(--ds-icon-success, ${$6fnsQ.G400})`,
                    label: "Success"
                }),
                description: /*#__PURE__*/ (0, $l998X.jsx)($75181cea81fbaddd$var$Description, {}),
                id: messageId,
                title: /*#__PURE__*/ (0, $l998X.jsx)($75181cea81fbaddd$var$Title, {}),
                appearance: 'normal',
                onDismissed: ()=>onDismissed(messageId)
            }, messageId))
    });
};
const $75181cea81fbaddd$export$887afb916153c3fb = ()=>{
    const [dismissedMessageIds, setDismissedMessageIds] = (0, $42omo.useState)([]);
    return {
        dismissedMessageIds: dismissedMessageIds,
        showFlag: (dismissedMessageId)=>setDismissedMessageIds((current)=>[
                    ...current,
                    dismissedMessageId
                ]),
        handleDismissFlag: (dismissedMessageId)=>setDismissedMessageIds((0, $8d3e387dfec25223$export$f9a3c275d8ffdac0)(dismissedMessageId))
    };
};


/* skeleton-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");





var $lYygP = parcelRequire("lYygP");

const $2e1ba8ce904738f1$var$iconSkeletonStyles = null;
const $2e1ba8ce904738f1$var$lineSkeletonStyles = null;
const $2e1ba8ce904738f1$var$iconSkeleton = /*#__PURE__*/ (0, $l998X.jsx)("div", {
    className: (0, $gMc0m.default)([
        "_2rko1mok _1e0c1o8l _1bsbzwfg _4t3izwfg _bfhkizff"
    ])
});
const $2e1ba8ce904738f1$var$lineSkeleton = /*#__PURE__*/ (0, $l998X.jsx)("div", {
    className: (0, $gMc0m.default)([
        "_2rkofajl _1e0c1o8l _1bsb1uc6 _4t3i19bv _bfhkizff"
    ])
}); // TODO: Export this as a primitive from Switcher instead of creating it here
const $2e1ba8ce904738f1$export$d281ba7ce1dcaa47 = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lYygP.default), {
        tag: "li",
        icon: $2e1ba8ce904738f1$var$iconSkeleton,
        isDisabled: true,
        children: $2e1ba8ce904738f1$var$lineSkeleton
    });
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for client side use only
#
# Generate source: local/cli/src/commands/placements/generate-placement-files.ts
*/ 
var $cyz5M = parcelRequire("cyz5M");

/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 












var $05c16971a334a19d$export$2e2bcd8739ae039 = {
    'recommendation-atlas': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("htETB"))),
    'recommendation-confluence': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("jH6vh"))),
    'recommendation-jpd': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2vN9b"))),
    'recommendation-jsm': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("ifHmH"))),
    'recommendation-jsw': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("fFXYB"))),
    'recommendation-jsw-dynamic-description': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("WInM3"))),
    'recommendation-jwm': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2K1ut"))),
    'recommendation-loom': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dFIhV"))),
    'recommendation-opsgenie': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("lLGes"))),
    'recommendation-twc': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("31QCn")))
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 



var $2d3eaf535df8ab6d$export$2e2bcd8739ae039 = {
    'message-template-template': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("8Mhd2")))
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 



var $59486e023b77d45f$export$2e2bcd8739ae039 = {
    'recommendation-jsw-jtbd': /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("f0ypi")))
};






var $3Shv6 = parcelRequire("3Shv6");


var $gVWoV = parcelRequire("gVWoV");


var $jVJ5P = parcelRequire("jVJ5P");








var $957Zh = parcelRequire("957Zh");

const { createRender: $c82604529abd935d$export$78c758434c34d601, createValidate: $c82604529abd935d$export$2859a83e4d6da57d } = (0, $957Zh.createClientPipeline)();
const { createHydrate: $c82604529abd935d$export$c905bc718befd59b, createHydrateExample: $c82604529abd935d$export$1f41223e5b0a6622, createTransformMetadata: $c82604529abd935d$export$88fe13b4d13f8423 } = (0, $957Zh.createServerPipeline)();


const $540afcd50fad0c8e$var$TEST_CONTENT = /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
    id: "test-messages.app-switcher-discovery-section.test-content",
    defaultMessage: "This is a test message."
});
const $540afcd50fad0c8e$export$b3890eb0ae9dca99 = (0, $c82604529abd935d$export$78c758434c34d601)(({ onDismissed: onDismissed })=>{
    const { messageInstanceId: messageInstanceId } = (0, $3Shv6.useMessageContext)();
    const { messageDismissed: messageDismissed } = (0, $jVJ5P.useMessageEvent)();
    const { messageInstanceClicked: messageInstanceClicked } = (0, $gVWoV.useMessageInstanceEvent)();
    const handleOnClick = (0, $42omo.useCallback)(async ()=>{
        if (messageInstanceId) {
            await messageDismissed();
            await messageInstanceClicked({
                messageEventType: 'clicked',
                clickedElement: {
                    clickIdentifier: 'dismiss',
                    clickedElement: 'button',
                    buttonType: 'primary'
                },
                action: {
                    actionType: 'dismiss'
                },
                additionalMetadataFromFrontend: {}
            });
            onDismissed(messageInstanceId);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        messageInstanceId,
        messageDismissed,
        messageInstanceClicked
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("p", {
                children: $540afcd50fad0c8e$var$TEST_CONTENT
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("button", {
                onClick: handleOnClick,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    id: "test-messages.app-switcher-discovery-section.dismiss",
                    defaultMessage: "Dismiss"
                })
            })
        ]
    });
});
var $540afcd50fad0c8e$export$2e2bcd8739ae039 = $540afcd50fad0c8e$export$b3890eb0ae9dca99;























const { createRender: $c5af54b443e8bce5$export$78c758434c34d601, createValidate: $c5af54b443e8bce5$export$2859a83e4d6da57d } = (0, $957Zh.createClientPipeline)();
const { createHydrate: $c5af54b443e8bce5$export$c905bc718befd59b, createHydrateExample: $c5af54b443e8bce5$export$1f41223e5b0a6622, createTransformMetadata: $c5af54b443e8bce5$export$88fe13b4d13f8423 } = (0, $957Zh.createServerPipeline)();


const $43d5efd35e694ba7$var$TEST_CONTENT = /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
    id: "test-messages.app-switcher-discovery-section.test-content",
    defaultMessage: "This is a test message."
});
const $43d5efd35e694ba7$export$b3890eb0ae9dca99 = (0, $c5af54b443e8bce5$export$78c758434c34d601)(({ onDismissed: onDismissed })=>{
    const { messageInstanceId: messageInstanceId } = (0, $3Shv6.useMessageContext)();
    const { messageDismissed: messageDismissed } = (0, $jVJ5P.useMessageEvent)();
    const { messageInstanceClicked: messageInstanceClicked } = (0, $gVWoV.useMessageInstanceEvent)();
    const handleOnClick = (0, $42omo.useCallback)(async ()=>{
        if (messageInstanceId) {
            await messageDismissed();
            await messageInstanceClicked({
                messageEventType: 'clicked',
                clickedElement: {
                    clickIdentifier: 'dismiss',
                    clickedElement: 'button',
                    buttonType: 'primary'
                },
                action: {
                    actionType: 'dismiss'
                },
                additionalMetadataFromFrontend: {}
            });
            onDismissed(messageInstanceId);
        }
    }, [
        messageInstanceId,
        messageDismissed,
        messageInstanceClicked
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("p", {
                children: $43d5efd35e694ba7$var$TEST_CONTENT
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("button", {
                onClick: handleOnClick,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    id: "test-messages.app-switcher-discovery-section.dismiss",
                    defaultMessage: "Dismiss"
                })
            })
        ]
    });
});
var $43d5efd35e694ba7$export$2e2bcd8739ae039 = $43d5efd35e694ba7$export$b3890eb0ae9dca99;





const $721d2dec798263a4$var$PRODUCT_NAME = 'Jira Software';
const $721d2dec798263a4$export$4199a33c3dd48123 = ({ onDismissed: onDismissed })=>/*#__PURE__*/ (0, $l998X.jsx)("button", {
        onClick: ()=>onDismissed('SOME_MESSAGE_INSTANCE'),
        children: $721d2dec798263a4$var$PRODUCT_NAME
    });
const $721d2dec798263a4$export$b3890eb0ae9dca99 = $721d2dec798263a4$export$4199a33c3dd48123;
var $721d2dec798263a4$export$2e2bcd8739ae039 = $721d2dec798263a4$export$4199a33c3dd48123;


const $1747fe69d2df31f5$export$e30378e28ad3e6ab = {
    ...(0, $05c16971a334a19d$export$2e2bcd8739ae039),
    ...(0, $2d3eaf535df8ab6d$export$2e2bcd8739ae039),
    ...(0, $59486e023b77d45f$export$2e2bcd8739ae039),
    'test-message-inapp': (0, $540afcd50fad0c8e$export$2e2bcd8739ae039),
    'test-message-inapp-engagement': (0, $43d5efd35e694ba7$export$2e2bcd8739ae039),
    'test-message-marketing': (0, $721d2dec798263a4$export$2e2bcd8739ae039)
};
const { initializeMessageRenderer: $1747fe69d2df31f5$export$bce4e5106d86e473, MessageRenderer: $1747fe69d2df31f5$export$2df1250b8f917a59 } = (0, $cyz5M.asMessageRenderer)($1747fe69d2df31f5$export$e30378e28ad3e6ab);


/**
 * This file was automatically generated using "yarn generate:all" command.
 * Please do not edit it manually.
 * 
 * Generate source: local/cli/src/commands/placements/generate-intl-provider.ts
 **/ 
var $jQRRW = parcelRequire("jQRRW");


var $3nDO6 = parcelRequire("3nDO6");


var $8SCD0 = parcelRequire("8SCD0");

/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $5opuK = parcelRequire("5opuK");


var $eoZW1 = parcelRequire("eoZW1");

// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $cae2500566e87d72$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $cae2500566e87d72$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("7AvKE")));
        case 'da':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("dJNU0")));
        case 'de':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("bzCKD")));
        case 'en-GB':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("8wRvu")));
        case 'en-US':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("e3q8K")));
        case 'en-XA':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("7nJeO")));
        case 'en-XB':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("3VF9G")));
        case 'en-ZZ':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("2vHaT")));
        case 'en':
            return $cae2500566e87d72$var$importHelper(await Promise.resolve((parcelRequire("5opuK"))));
        case 'es':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("enZIi")));
        case 'et':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("55TRj")));
        case 'fi':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("8TpLk")));
        case 'fr':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("h839E")));
        case 'hr':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("8qg3C")));
        case 'hu':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("gYovK")));
        case 'it':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("dL3nl")));
        case 'ja':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("khzSf")));
        case 'ko':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("h9Cqt")));
        case 'nb':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("anMk0")));
        case 'nl':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("gTcJ1")));
        case 'pl':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("koaDM")));
        case 'pt-BR':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("5BcBO")));
        case 'ro':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("gJAuJ")));
        case 'ru':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("hf5oO")));
        case 'sl':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("fVjkT")));
        case 'sr-RS':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("jkhZ7")));
        case 'sr-YR':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("kQtHz")));
        case 'sr':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("bk3g3")));
        case 'sv':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("b0F2h")));
        case 'th':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("gn9ba")));
        case 'tr':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("cZmiY")));
        case 'uk':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("errUO")));
        case 'vi':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("bEAyC")));
        case 'zh-CN':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("896lS")));
        case 'zh-TW':
            return $cae2500566e87d72$var$importHelper(await (parcelRequire("gp8P2")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($5opuK));
    }
};



var $kdvUL = parcelRequire("kdvUL");

const $a62d024fdde04888$export$d5a462ce7bd04520 = async (locale)=>{
    return Promise.allSettled([
        (0, $3nDO6.messagesLoader)(locale),
        (0, $8SCD0.messagesLoader)(locale),
        (0, $cae2500566e87d72$export$720676d8cac8fbb)(locale),
        (0, $kdvUL.messagesLoader)(locale)
    ]).then((results)=>{
        return results.reduce((acc, result)=>{
            if (result.status === 'fulfilled') return {
                messages: {
                    ...acc.messages,
                    ...result.value
                },
                errors: [
                    ...acc.errors
                ]
            };
            else if (result.status === 'rejected') return {
                messages: {
                    ...acc.messages
                },
                errors: [
                    ...acc.errors,
                    `Failed to load translations with ${result.reason}`
                ]
            };
            return acc;
        }, {
            messages: {},
            errors: []
        });
    });
};
const $a62d024fdde04888$export$b73a0b4f9b1b8821 = (Component)=>{
    return (0, $jQRRW.withIntlProvider)({
        messagesLoader: $a62d024fdde04888$export$d5a462ce7bd04520
    }, Component);
};


const $60de571a416785ce$var$adminSwitcherItemStyle = null;
const $60de571a416785ce$var$MoreAtlassianAppsIcon = ({ size: size = 'medium', label: label = '', testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $i7jPX.default), {
        label: label,
        size: size,
        isInset: false,
        backgroundColor: "white",
        testId: testId,
        children: /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
            height: "100%",
            viewBox: "0 0 24 24",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    fill: "#dddee1",
                    d: "M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    fill: "#101214",
                    d: "M11.13 5.88H5.88v5.25h5.25zm0 7H5.88v5.25h5.25zm1.75-7h5.25v5.25h-5.25zm5.25 7h-5.25v5.25h5.25z"
                })
            ]
        })
    });
const $60de571a416785ce$var$discoverMoreProductsTitle = /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
    id: "app-switcher-discovery-section.discover-more-products",
    defaultMessage: "Discover more apps"
});
const $60de571a416785ce$var$recommendedForYourTeamTitle = /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
    id: "app-switcher-discovery-section.recommended-for-your-team",
    defaultMessage: "Recommended for your team"
});
const $60de571a416785ce$var$moreAtlassianProducts = /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
    id: "app-switcher-discovery-section.more-atlassian-products",
    defaultMessage: "More Atlassian apps"
});
const $60de571a416785ce$var$CROSS_FLOW_SOURCE_COMPONENT = 'atlassian-switcher';
const $60de571a416785ce$var$CROSS_FLOW_SOURCE_CONTEXT = 'more';
const $60de571a416785ce$var$PLACEMENT_ID = 'app-switcher-discovery-section'; // Jira Local Consumption - MessageRenderer is typed as 'React.FC<any>' as otherwise it fails typecheck within Jira with the below error:
const $60de571a416785ce$export$2df1250b8f917a59 = (0, $1747fe69d2df31f5$export$bce4e5106d86e473)();
const $60de571a416785ce$export$6b2f07b528cc1aa5 = (0, $a62d024fdde04888$export$b73a0b4f9b1b8821)((0, $2mPpz.createPlacementComponent)($60de571a416785ce$var$PLACEMENT_ID, ({ initialData: initialData, extraAnalyticsAttributes: extraAnalyticsAttributes })=>{
    const initialDataState = (0, $6Ht9d.useInitialData)(initialData);
    const crossFlow = (0, $2YerA.useCrossFlow)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    const isInWacContext = (0, $4nMma.useIsWacContext)();
    const handleClickMoreAtlassianProducts = (0, $42omo.useCallback)(async ()=>{
        if (crossFlow.isEnabled) {
            fireAnalyticsEvent({
                eventType: 'ui',
                action: 'clicked',
                actionSubject: 'listItem',
                actionSubjectId: 'discoverMoreAtlassianProductsButton'
            });
            await crossFlow.api.open({
                journey: (0, $2YerA.Journeys).DISCOVER,
                sourceComponent: $60de571a416785ce$var$CROSS_FLOW_SOURCE_COMPONENT,
                sourceContext: $60de571a416785ce$var$CROSS_FLOW_SOURCE_CONTEXT
            });
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const [dismissedMessageInstanceIds, setDismissedMessageInstanceIds] = (0, $42omo.useState)([]);
    const { dismissedMessageIds: dismissedMessageIds, showFlag: showFlag, handleDismissFlag: handleDismissFlag } = (0, $75181cea81fbaddd$export$887afb916153c3fb)();
    const { fireViewedUIEvent: fireViewedUIEvent } = (0, $lfQiY.useFireCrossFlowAnalyticsEvents)();
    const { isSiteAdmin: isSiteAdmin, tenantId: tenantId } = (0, $PAiZW.usePostOfficeContext)();
    const handleOnDismissed = (0, $42omo.useCallback)((dismissedMessageInstanceId)=>{
        setDismissedMessageInstanceIds([
            ...dismissedMessageInstanceIds,
            dismissedMessageInstanceId
        ]);
        showFlag(dismissedMessageInstanceId);
    }, [
        dismissedMessageInstanceIds,
        showFlag
    ]);
    const { optoutStatus: optoutStatus } = (0, $db3d188af07fd475$export$7d4c6b519725ba3b)('app-switcher-discovery-section', tenantId || '', initialDataState.data?.atlassianAccountId, {
        isDisabled: !(0, $c6GJD.default).checkGate('optout_all_messages_app_switcher_discovery')
    });
    const isOptedOut = (0, $c6GJD.default).checkGate('optout_all_messages_app_switcher_discovery') && optoutStatus !== 'no-opt-out';
    const isSwitcherUnifiedInstrumentationEnabled = (0, $c6GJD.default).checkGate('navx-app-switcher-unified-instrumentation-fe');
    (0, $42omo.useEffect)(()=>{
        if (initialDataState.data?.messages) {
            const productIds = initialDataState.data.messages.map((message)=>$60de571a416785ce$var$getProductIdFromMessageTemplateId(message.messageTemplateId)).filter(Boolean);
            fireViewedUIEvent({
                action: 'viewed',
                actionSubject: 'section',
                actionSubjectId: 'atlassianSwitcherDiscoverProducts'
            }, {
                source: 'atlassianSwitcherDiscoverProductsSection',
                recommendedProductIds: productIds
            }, {
                isSiteAdmin: isSiteAdmin
            }); // Notify switcher that discovery section is rendering with content via custom DOM event
            if (isSwitcherUnifiedInstrumentationEnabled) {
                if (!initialDataState.isLoading && !(messages.length === 0 && isOptedOut)) (0, $9irGW.notifyDiscoverySectionRendered)(true);
            }
        }
    }, [
        fireViewedUIEvent,
        initialDataState.data?.messages,
        isSiteAdmin
    ]);
    if (initialDataState.error) {
        if (isSwitcherUnifiedInstrumentationEnabled) (0, $9irGW.notifyDiscoverySectionRendered)(false);
        return null;
    }
    if (initialDataState.isLoading) return /*#__PURE__*/ (0, $l998X.jsx)((0, $hRQgD.default), {});
    const messages = initialDataState?.data?.messages;
    const messagesWithoutDismissed = messages.filter((message)=>!dismissedMessageInstanceIds.includes(message.messageInstanceId));
    const decideTitle = ()=>{
        if (isInWacContext && messagesWithoutDismissed.length === 0) return null;
        return messagesWithoutDismissed.length > 0 ? $60de571a416785ce$var$recommendedForYourTeamTitle : $60de571a416785ce$var$discoverMoreProductsTitle;
    };
    const title = decideTitle();
    if (messages.length === 0 && isOptedOut) return null;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $fJvXe.SectionContainer), {
        sectionId: "discover",
        title: title,
        children: [
            messagesWithoutDismissed.map((message)=>/*#__PURE__*/ (0, $l998X.jsx)($60de571a416785ce$export$2df1250b8f917a59, {
                    ...message,
                    onDismissed: handleOnDismissed,
                    loadingFallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $2e1ba8ce904738f1$export$d281ba7ce1dcaa47), {}),
                    extraAnalyticsAttributes: extraAnalyticsAttributes
                }, message.messageInstanceId)),
            isInWacContext ? null : /*#__PURE__*/ (0, $l998X.jsx)((0, $6FJLn.default), {
                onClick: handleClickMoreAtlassianProducts,
                icon: /*#__PURE__*/ (0, $l998X.jsx)("span", {
                    className: (0, $gMc0m.default)([
                        "_2rko1mok _1reo15vq _18m915vq _bfhki8nm _syaz1rpy _1e0c1txw _1bsbxy5q _4t3ixy5q _4cvr1h6o _1bah1h6o"
                    ]),
                    children: $60de571a416785ce$var$MoreAtlassianAppsIcon({
                        // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
                        label: 'Discover More',
                        testId: 'app-switcher-discover-more-section__icon'
                    })
                }),
                children: $60de571a416785ce$var$moreAtlassianProducts
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $75181cea81fbaddd$export$a309243da00b18dc), {
                dismissedMessageIds: dismissedMessageIds,
                handleDismissFlag: handleDismissFlag
            })
        ]
    });
}, {
    choreographer: {
        isDefaultEnabled: false
    },
    hideInIsolatedCloud: true
}));
const $60de571a416785ce$var$MESSAGE_TEMPLATE_ID_TO_PRODUCT_ID_MAP = {
    'recommendation-atlas': '7c917705-866d-4b6b-b266-0fc7633e8342',
    'recommendation-confluence': '6aab3f4e-cc71-474d-8d28-abef8b057808',
    'recommendation-jpd': 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    'recommendation-jsm': 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    'recommendation-jsw': 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    'recommendation-jwm': '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    'recommendation-loom': '7683a73e-423d-41a1-b43f-d497656f8b5d',
    'recommendation-opsgenie': 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
    'recommendation-rovo': '91ae3e3f-138e-43be-98cc-48df03d13c32',
    // TWC message instances
    'recommendation-twc': '3503c251-c247-4b55-a6ed-d4c8c3257b8b'
}; // This is a temporary mapping for this placement to contribute to go/crossflowfunnel
// It will be fixed in the future by updating the dashboard to read directly from PO analytics
const $60de571a416785ce$var$getProductIdFromMessageTemplateId = (messageTemplateId)=>{
    return $60de571a416785ce$var$MESSAGE_TEMPLATE_ID_TO_PRODUCT_ID_MAP[messageTemplateId];
};
var $60de571a416785ce$export$2e2bcd8739ae039 = $60de571a416785ce$export$6b2f07b528cc1aa5;
module.exports["default"] = $60de571a416785ce$export$2e2bcd8739ae039;

});

parcelRegister("4nMma", function(module, exports) {

var $PAiZW = parcelRequire("PAiZW");

const $e815e8986f234c20$export$55ed4fa25efa6fad = {
    WAC: 'marketing'
};
const $e815e8986f234c20$export$40cd2d71062b3400 = 'segment_confluence_mau_not_mcu_with_user_tenure_greater_than_90_days_siteuser';
const $e815e8986f234c20$export$f9ae93b6f9702050 = 'post-office_expt_confluence-comments-nudge';
const $e815e8986f234c20$export$986ddb6ade6c1357 = 'segment_paying_sites_less_than_60_days_old_siteid';
const $e815e8986f234c20$export$bf0b0c402d9ebd25 = 'segment_partner_managed_tenants_siteid';
const $e815e8986f234c20$export$e4025b4a2a2f1a21 = 'segment_jira_recently_inactive_peu_non_mau_siteuser';
const $e815e8986f234c20$export$e185c4694f5d6aa0 = 'post-office-jira-slack-assigned-nudge-experiment-2';
const $e815e8986f234c20$export$e3e34056deab7ac7 = 'post-office-jira-assigned-nudge-tap-aud-check-gate';


const $0732a3e86f92a543$export$4e9304272964deb6 = ()=>{
    const context = (0, $PAiZW.usePostOfficeContext)();
    return context.product === (0, $e815e8986f234c20$export$55ed4fa25efa6fad).WAC;
};
const $0732a3e86f92a543$export$631ba87ff5b9e288 = (microsEnvType)=>{
    switch(microsEnvType){
        case 'dev':
            return 'https://admin.dev.atlassian.com';
        case 'staging':
            return 'https://admin.stg.atlassian.com';
        default:
            return 'https://admin.atlassian.com';
    }
};
module.exports["useIsWacContext"] = $0732a3e86f92a543$export$4e9304272964deb6;

});

parcelRegister("htETB", function(module, exports) {

let $cb94de2b6155420d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cb94de2b6155420d$var$load("6wr18"),
    $cb94de2b6155420d$var$load("8gQKz"),
    $cb94de2b6155420d$var$load("hhss7"),
    $cb94de2b6155420d$var$load("ffEVr"),
    $cb94de2b6155420d$var$load("awqCy"),
    $cb94de2b6155420d$var$load("6m2wP")
]).then(()=>parcelRequire('h3wNo'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("jH6vh", function(module, exports) {

let $e56713eb7dee28a0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e56713eb7dee28a0$var$load("6wr18"),
    $e56713eb7dee28a0$var$load("8gQKz"),
    $e56713eb7dee28a0$var$load("hhss7"),
    $e56713eb7dee28a0$var$load("ffEVr"),
    $e56713eb7dee28a0$var$load("awqCy"),
    $e56713eb7dee28a0$var$load("gopxm")
]).then(()=>parcelRequire('1BKEb'));

});

parcelRegister("2vN9b", function(module, exports) {

let $1d44999bbac8d4ec$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1d44999bbac8d4ec$var$load("6wr18"),
    $1d44999bbac8d4ec$var$load("8gQKz"),
    $1d44999bbac8d4ec$var$load("hhss7"),
    $1d44999bbac8d4ec$var$load("ffEVr"),
    $1d44999bbac8d4ec$var$load("awqCy"),
    $1d44999bbac8d4ec$var$load("9N316")
]).then(()=>parcelRequire('4cOCK'));

});

parcelRegister("ifHmH", function(module, exports) {

let $d49b4421b1bac106$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d49b4421b1bac106$var$load("6wr18"),
    $d49b4421b1bac106$var$load("8gQKz"),
    $d49b4421b1bac106$var$load("hhss7"),
    $d49b4421b1bac106$var$load("ffEVr"),
    $d49b4421b1bac106$var$load("awqCy"),
    $d49b4421b1bac106$var$load("603iI")
]).then(()=>parcelRequire('jGNAq'));

});

parcelRegister("fFXYB", function(module, exports) {

let $b6993572d1e021ad$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b6993572d1e021ad$var$load("6wr18"),
    $b6993572d1e021ad$var$load("8gQKz"),
    $b6993572d1e021ad$var$load("hhss7"),
    $b6993572d1e021ad$var$load("ffEVr"),
    $b6993572d1e021ad$var$load("awqCy"),
    $b6993572d1e021ad$var$load("dVwBo")
]).then(()=>parcelRequire('hLkI7'));

});

parcelRegister("WInM3", function(module, exports) {

let $0b07d85338be03df$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0b07d85338be03df$var$load("6wr18"),
    $0b07d85338be03df$var$load("8gQKz"),
    $0b07d85338be03df$var$load("hhss7"),
    $0b07d85338be03df$var$load("ffEVr"),
    $0b07d85338be03df$var$load("awqCy"),
    $0b07d85338be03df$var$load("ipxYo")
]).then(()=>parcelRequire('6h9cg'));

});

parcelRegister("2K1ut", function(module, exports) {

let $1ff108a455aff1f0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1ff108a455aff1f0$var$load("6wr18"),
    $1ff108a455aff1f0$var$load("8gQKz"),
    $1ff108a455aff1f0$var$load("hhss7"),
    $1ff108a455aff1f0$var$load("ffEVr"),
    $1ff108a455aff1f0$var$load("awqCy"),
    $1ff108a455aff1f0$var$load("l37ax")
]).then(()=>parcelRequire('7Z4Bp'));

});

parcelRegister("dFIhV", function(module, exports) {

let $9f41756728352f88$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9f41756728352f88$var$load("6wr18"),
    $9f41756728352f88$var$load("8gQKz"),
    $9f41756728352f88$var$load("hhss7"),
    $9f41756728352f88$var$load("ffEVr"),
    $9f41756728352f88$var$load("awqCy"),
    $9f41756728352f88$var$load("ntv3W")
]).then(()=>parcelRequire('itIol'));

});

parcelRegister("lLGes", function(module, exports) {

let $fd8ebf306e2c26d8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fd8ebf306e2c26d8$var$load("6wr18"),
    $fd8ebf306e2c26d8$var$load("8gQKz"),
    $fd8ebf306e2c26d8$var$load("hhss7"),
    $fd8ebf306e2c26d8$var$load("ffEVr"),
    $fd8ebf306e2c26d8$var$load("awqCy"),
    $fd8ebf306e2c26d8$var$load("1b5ye")
]).then(()=>parcelRequire('mhFvJ'));

});

parcelRegister("31QCn", function(module, exports) {

let $234a47f3e408e73a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $234a47f3e408e73a$var$load("6wr18"),
    $234a47f3e408e73a$var$load("8gQKz"),
    $234a47f3e408e73a$var$load("kiGNy"),
    $234a47f3e408e73a$var$load("dXs0A"),
    $234a47f3e408e73a$var$load("hhss7"),
    $234a47f3e408e73a$var$load("ffEVr"),
    $234a47f3e408e73a$var$load("awqCy"),
    $234a47f3e408e73a$var$load("f2tLs"),
    $234a47f3e408e73a$var$load("Wowvf"),
    $234a47f3e408e73a$var$load("h3ABO"),
    $234a47f3e408e73a$var$load("lXsOU")
]).then(()=>parcelRequire('S2mve'));

});

parcelRegister("8Mhd2", function(module, exports) {

let $664027d2feb92de4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $664027d2feb92de4$var$load("eEBx4").then(()=>parcelRequire('cuPHJ'));

});

parcelRegister("f0ypi", function(module, exports) {

let $aed18ba0c0a9f576$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $aed18ba0c0a9f576$var$load("6wr18"),
    $aed18ba0c0a9f576$var$load("8gQKz"),
    $aed18ba0c0a9f576$var$load("hhss7"),
    $aed18ba0c0a9f576$var$load("ffEVr"),
    $aed18ba0c0a9f576$var$load("awqCy"),
    $aed18ba0c0a9f576$var$load("6gEtt")
]).then(()=>parcelRequire('7HoFq'));

});

parcelRegister("5opuK", function(module, exports) {
module.exports = JSON.parse('{"trailblazers.recommendation-jsw-jtbd.generic.description":[{"type":0,"value":"Track work from start to finish"}],"trailblazers.recommendation-jsw-jtbd.generic.jtbd":[{"type":0,"value":"Project board"}],"trailblazers.recommendation-jsw-jtbd.lozenge.try":[{"type":0,"value":"Try"}],"trailblazers.recommendation-jsw-jtbd.marketing.description":[{"type":0,"value":"Easily plan and prioritize work"}],"trailblazers.recommendation-jsw-jtbd.marketing.jtbd":[{"type":0,"value":"Marketing project"}],"trailblazers.recommendation-jsw-jtbd.operations.description":[{"type":0,"value":"Visualize, plan, and finish work"}],"trailblazers.recommendation-jsw-jtbd.operations.jtbd":[{"type":0,"value":"Operations project"}],"trailblazers.recommendation-jsw-jtbd.pm.description":[{"type":0,"value":"See work in to-do, doing, done"}],"trailblazers.recommendation-jsw-jtbd.pm.jtbd":[{"type":0,"value":"Plan and track work"}],"trailblazers.recommendation-jsw-jtbd.swe.description":[{"type":0,"value":"Track work from start to finish"}],"trailblazers.recommendation-jsw-jtbd.swe.jtbd":[{"type":0,"value":"Project tracker"}],"trailblazers.xflow-notification-end-user-added-jira.message-template.email.subject":[{"type":0,"value":"\uD83C\uDF89 "},{"type":1,"value":"name"},{"type":0,"value":" has started using Jira"}],"trailblazers.xflow-notification-end-user-added-jira.message.email.admin-url.no-translate":[{"type":0,"value":"admin.atlassian.com"}],"trailblazers.xflow-notification-end-user-added-jira.message.email.headline":[{"type":1,"value":"name"},{"type":0,"value":" has started using Jira!"}],"trailblazers.xflow-notification-end-user-added-jira.message.email.lead-paragraph":[{"type":0,"value":"Jira has been added to "},{"type":1,"value":"instanceUrl"},{"type":0,"value":". You don\u2019t need to do anything. "},{"children":[{"type":0,"value":"Jira is free for up to 10 users."}],"type":8,"value":"b"},{"type":0,"value":" You can cancel any time at "}],"trailblazers.xflow-notification-end-user-added-jira.message.email.sent-by-atlassian":[{"type":0,"value":"This message has been sent to you by Atlassian Cloud"}],"trailblazers.xflow-notification-end-user-added-jira.message.email.take-tour.button":[{"type":0,"value":"Take a tour"}],"trailblazers.xflow-notification-end-user-added-jira.message.email.value-prop.achievable-tasks":[{"type":0,"value":"\uD83D\uDE80 Jira is a tool designed to break down any idea into achievable tasks."}],"trailblazers.xflow-notification-end-user-added-jira.message.email.value-prop.connect-realtime":[{"type":0,"value":"\u2194\uFE0F Connect real-time data from Jira to any document in Confluence, no more copy paste."}],"trailblazers.xflow-notification-end-user-added-jira.message.email.value-prop.visualise":[{"type":0,"value":"\uD83D\uDC40 Visualize your projects in lists, boards, backlogs, and more."}]}');

});

parcelRegister("7AvKE", function(module, exports) {

let $5864865cd1acffca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5864865cd1acffca$var$load("br5B5").then(()=>parcelRequire('g1ao0'));

});

parcelRegister("dJNU0", function(module, exports) {

let $a0062fdfc076c223$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a0062fdfc076c223$var$load("gjHAC").then(()=>parcelRequire('btnnE'));

});

parcelRegister("bzCKD", function(module, exports) {

let $86d105cb9affc84e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $86d105cb9affc84e$var$load("50jL1").then(()=>parcelRequire('bGslt'));

});

parcelRegister("8wRvu", function(module, exports) {

let $635ad13be0779c84$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $635ad13be0779c84$var$load("icT1H").then(()=>parcelRequire('1a85K'));

});

parcelRegister("e3q8K", function(module, exports) {

let $a3b59f609b062313$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a3b59f609b062313$var$load("jHACf").then(()=>parcelRequire('blZ2O'));

});

parcelRegister("7nJeO", function(module, exports) {

let $55fdc5ab821883c8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $55fdc5ab821883c8$var$load("gxykq").then(()=>parcelRequire('aLFng'));

});

parcelRegister("3VF9G", function(module, exports) {

let $2dc69e8e68c41492$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2dc69e8e68c41492$var$load("jwi3q").then(()=>parcelRequire('kLNrh'));

});

parcelRegister("2vHaT", function(module, exports) {

let $1d3ff7a4652d484e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1d3ff7a4652d484e$var$load("4vq5I").then(()=>parcelRequire('8KTi9'));

});

parcelRegister("enZIi", function(module, exports) {

let $a79315b421ac5757$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a79315b421ac5757$var$load("3IaOg").then(()=>parcelRequire('1Lf8R'));

});

parcelRegister("55TRj", function(module, exports) {

let $3b58bfcf410f2840$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3b58bfcf410f2840$var$load("c1t91").then(()=>parcelRequire('5X1X6'));

});

parcelRegister("8TpLk", function(module, exports) {

let $679771a82988fe1d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $679771a82988fe1d$var$load("5x1Zd").then(()=>parcelRequire('eA4kS'));

});

parcelRegister("h839E", function(module, exports) {

let $c785a17d8e3a1ee6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c785a17d8e3a1ee6$var$load("eNry3").then(()=>parcelRequire('l5c5e'));

});

parcelRegister("8qg3C", function(module, exports) {

let $621d351752d968ae$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $621d351752d968ae$var$load("cmudZ").then(()=>parcelRequire('hRCZa'));

});

parcelRegister("gYovK", function(module, exports) {

let $c5b5434ff6adb258$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c5b5434ff6adb258$var$load("qOVvt").then(()=>parcelRequire('lKBwT'));

});

parcelRegister("dL3nl", function(module, exports) {

let $a0424876bbdc61a8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a0424876bbdc61a8$var$load("cLRtU").then(()=>parcelRequire('CZrZ8'));

});

parcelRegister("khzSf", function(module, exports) {

let $ec4138fd7d6cb834$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ec4138fd7d6cb834$var$load("fWDs2").then(()=>parcelRequire('86TZ1'));

});

parcelRegister("h9Cqt", function(module, exports) {

let $c7d11589f4bed28e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c7d11589f4bed28e$var$load("isQud").then(()=>parcelRequire('6aeYa'));

});

parcelRegister("anMk0", function(module, exports) {

let $78f1890952f51f4e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $78f1890952f51f4e$var$load("iX3CG").then(()=>parcelRequire('f34NH'));

});

parcelRegister("gTcJ1", function(module, exports) {

let $c4bba754ab8db037$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c4bba754ab8db037$var$load("5GFyb").then(()=>parcelRequire('jiVgR'));

});

parcelRegister("koaDM", function(module, exports) {

let $ed7e4d8f2a387381$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ed7e4d8f2a387381$var$load("fDZox").then(()=>parcelRequire('5zdhe'));

});

parcelRegister("5BcBO", function(module, exports) {

let $413a304ae06b490a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $413a304ae06b490a$var$load("gYq2J").then(()=>parcelRequire('gxD3N'));

});

parcelRegister("gJAuJ", function(module, exports) {

let $c2ed2868233e7199$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c2ed2868233e7199$var$load("4MDcN").then(()=>parcelRequire('8A4Kb'));

});

parcelRegister("hf5oO", function(module, exports) {

let $c8d8068e094a7f91$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c8d8068e094a7f91$var$load("djU0u").then(()=>parcelRequire('3qkos'));

});

parcelRegister("fVjkT", function(module, exports) {

let $b97b2da136263ff1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b97b2da136263ff1$var$load("gUvh2").then(()=>parcelRequire('hUV1e'));

});

parcelRegister("jkhZ7", function(module, exports) {

let $e11dd5fe390d440b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e11dd5fe390d440b$var$load("kb7kZ").then(()=>parcelRequire('l9iLc'));

});

parcelRegister("kQtHz", function(module, exports) {

let $f2cfb41c578c96fe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f2cfb41c578c96fe$var$load("kGHpg").then(()=>parcelRequire('7cYHh'));

});

parcelRegister("bk3g3", function(module, exports) {

let $83e416efa85517c8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $83e416efa85517c8$var$load("8GEyD").then(()=>parcelRequire('d8z8o'));

});

parcelRegister("b0F2h", function(module, exports) {

let $803f869f23db75dd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $803f869f23db75dd$var$load("gSB6X").then(()=>parcelRequire('fMlpz'));

});

parcelRegister("gn9ba", function(module, exports) {

let $beb5ea1a8706615f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $beb5ea1a8706615f$var$load("9s4Da").then(()=>parcelRequire('8LZxx'));

});

parcelRegister("cZmiY", function(module, exports) {

let $974c7bd57cf4df44$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $974c7bd57cf4df44$var$load("f73pl").then(()=>parcelRequire('iZMLO'));

});

parcelRegister("errUO", function(module, exports) {

let $a8393db48fb8c7b0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a8393db48fb8c7b0$var$load("jmWj5").then(()=>parcelRequire('bFdEh'));

});

parcelRegister("bEAyC", function(module, exports) {

let $87bfc9a658fb4d82$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $87bfc9a658fb4d82$var$load("inGUf").then(()=>parcelRequire('6PHXJ'));

});

parcelRegister("896lS", function(module, exports) {

let $5ee417570a20d217$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5ee417570a20d217$var$load("9rQBn").then(()=>parcelRequire('br3Yo'));

});

parcelRegister("gp8P2", function(module, exports) {

let $bf15d311627e5ca2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bf15d311627e5ca2$var$load("4DECc").then(()=>parcelRequire('5xVqA'));

});

parcelRegister("hNJxa", function(module, exports) {

var $k4HRJ = parcelRequire("k4HRJ");


var $jIyl9 = parcelRequire("jIyl9");


var $dcO0p = parcelRequire("dcO0p");

/* Joinable Sites API was replaced by Product Recommendations API as part of productionizing the Joinable Sites
   experimental API. This code maps Product Recommendations API results into Joinable Sites API results for
   compatibility with existing UI elements.
 */ function $0d4b4afaa84d28bb$var$productRecommendationsUrl(baseUrl) {
    return baseUrl + '/v1/product-recommendations' + '?product=jira-software&product=jira-servicedesk&product=confluence&product=jira-product-discovery';
}
/*
	Experiment API endpoint used to get collaborators to provided products
	https://bitbucket.org/atlassian/experiment-api/src/master/src/experiments/cross-join-switcher/
*/ const $0d4b4afaa84d28bb$var$collaboratorsUrl = '/gateway/api/growth/cross-join-switcher/get-eligible-collaborators';
// tenantedProducts and nonTenantedProducts used to identify which ARIs contain cloudId
// Also used to convert resourceOwner strings to JoinableSites product strings
const $0d4b4afaa84d28bb$var$supportedTenantedProducts = {
    confluence: (0, $dcO0p.ProductKey).CONFLUENCE,
    'jira-software': (0, $dcO0p.ProductKey).JIRA_SOFTWARE,
    'jira-product-discovery': (0, $dcO0p.ProductKey).JIRA_PRODUCT_DISCOVERY,
    'jira-servicedesk': (0, $dcO0p.ProductKey).JIRA_SERVICE_DESK
};
const $0d4b4afaa84d28bb$var$tenantedProductsToProduct = {
    [(0, $dcO0p.ProductKey).CONFLUENCE]: 'confluence',
    [(0, $dcO0p.ProductKey).JIRA_SOFTWARE]: 'jira-software',
    [(0, $dcO0p.ProductKey).JIRA_PRODUCT_DISCOVERY]: (0, $dcO0p.ProductKey).JIRA_PRODUCT_DISCOVERY,
    [(0, $dcO0p.ProductKey).JIRA_SERVICE_DESK]: 'jira-servicedesk'
};
function $0d4b4afaa84d28bb$var$handleCapabilities(capabilities) {
    return capabilities?.filter((inputResource)=>{
        const parsedAri = (0, $k4HRJ.AnyAri).parse(inputResource.resourceId);
        return $0d4b4afaa84d28bb$var$supportedTenantedProducts[parsedAri.resourceOwner] && parsedAri.resourceType === 'site';
    }).reduce((sites, inputValue, index)=>{
        const ari = (0, $k4HRJ.AnyAri).parse(inputValue.resourceId);
        const sitesProducts = sites[ari.resourceId]?.products;
        if (sitesProducts) {
            sitesProducts[$0d4b4afaa84d28bb$var$supportedTenantedProducts[ari.resourceOwner]] = {
                collaborators: [],
                productUrl: inputValue.url,
                capability: inputValue.capability
            };
            return sites;
        }
        try {
            // Add site with this product
            const url = new URL(inputValue.url);
            const products = {};
            products[$0d4b4afaa84d28bb$var$supportedTenantedProducts[ari.resourceOwner]] = {
                collaborators: [],
                productUrl: inputValue.url,
                capability: inputValue.capability
            };
            sites[ari.resourceId] = {
                cloudId: ari.resourceId,
                url: url.origin,
                displayName: inputValue.displayName,
                products: products,
                relevance: Math.max(1000 - index, 0)
            };
            return sites;
        } catch (e) {
            return sites;
        }
    }, {});
}
function $0d4b4afaa84d28bb$var$convertProductRecommendationsResponseToJoinableSitesResponse(input) {
    const joinedCapabilities = $0d4b4afaa84d28bb$var$handleCapabilities(input.capability?.DIRECT_ACCESS.map((site)=>({
            ...site,
            capability: 'DIRECT_ACCESS'
        })).concat(input.capability?.REQUEST_ACCESS.map((site)=>({
            ...site,
            capability: 'REQUEST_ACCESS'
        }))));
    return {
        sites: Object.values(joinedCapabilities)
    };
}
function $0d4b4afaa84d28bb$var$isPublicEmailDomainError(body) {
    // Public Email Domain Error returns a body with the following content:
    // {"code":"email-public-domain","message":"Request requires a domain which is not public"}
    return body?.code === 'email-public-domain';
}
const $0d4b4afaa84d28bb$var$emptyProductRecommendationResponse = {
    capability: {
        DIRECT_ACCESS: [],
        REQUEST_ACCESS: []
    }
};
const $0d4b4afaa84d28bb$export$194985100c06d296 = (url, init)=>fetch(url, {
        credentials: 'include',
        ...init
    }).then(async (response)=>{
        const jsonPromise = response.json();
        if (response.ok) return jsonPromise;
        if (response.status === 400) {
            const json = await jsonPromise;
            if ($0d4b4afaa84d28bb$var$isPublicEmailDomainError(json)) return $0d4b4afaa84d28bb$var$emptyProductRecommendationResponse;
        }
        throw new (0, $jIyl9.FetchError)(`Unable to fetch ${url} ${response.status} ${response.statusText}`, response.status);
    }).catch(()=>{
        throw new (0, $jIyl9.FetchError)('Network Error', undefined);
    });
async function $0d4b4afaa84d28bb$export$3273ac3481dc0616(cloudId = '', baseUrl = '') {
    const response = await $0d4b4afaa84d28bb$export$194985100c06d296($0d4b4afaa84d28bb$var$productRecommendationsUrl(baseUrl), {
        method: 'get'
    });
    const sitesResponse = $0d4b4afaa84d28bb$var$convertProductRecommendationsResponseToJoinableSitesResponse(response);
    if (!cloudId) return sitesResponse;
    const filteredSites = sitesResponse?.sites?.filter((site)=>site.cloudId === cloudId);
    // This mapping is required for calling the get-eligible-collaborators endpoint
    const flattenedProducts = filteredSites?.flatMap((site)=>Object.keys(site.products || []).map((productName)=>$0d4b4afaa84d28bb$var$tenantedProductsToProduct[productName]));
    if (!filteredSites || filteredSites?.length === 0 || flattenedProducts?.length === 0) return {
        sites: filteredSites
    };
    const collaboratorsResponse = await fetch($0d4b4afaa84d28bb$var$collaboratorsUrl, {
        method: 'POST',
        body: JSON.stringify({
            products: flattenedProducts,
            cloudId: cloudId
        }),
        headers: {
            'Content-Type': 'application/json'
        }
    });
    if (!collaboratorsResponse.ok) return {
        sites: filteredSites
    };
    const collaboratorsJson = await collaboratorsResponse.json();
    // Renames key with tenantedProducts and filters out empty responses
    const updatedProductCollaborators = Object.fromEntries(Object.entries(collaboratorsJson).filter((item)=>Array.isArray(item[1]) && item[1]?.length !== 0).map((item)=>{
        return [
            $0d4b4afaa84d28bb$var$supportedTenantedProducts[item[0]] || item[0],
            item[1].map(({ userProfile: userProfile })=>({
                    displayName: userProfile?.name || '',
                    avatarUrl: userProfile?.picture || ''
                }))
        ];
    }));
    const updatedProductCollaboratorsKeys = Object.keys(updatedProductCollaborators);
    // Inject collaborators with each related product
    // Inject users with each site.
    const sitesWithCollaborators = filteredSites.map((site)=>{
        updatedProductCollaboratorsKeys.forEach((collaboratorProductKey)=>{
            if (site?.products?.[collaboratorProductKey]) site.products[collaboratorProductKey].collaborators = updatedProductCollaborators[collaboratorProductKey];
        });
        site.users = Object.keys(site?.products || {}).reduce((users, product)=>{
            users[product] = updatedProductCollaborators[product] || [];
            return users;
        }, {});
        return site;
    });
    const updatedSiteResponse = {
        sites: sitesWithCollaborators
    };
    return updatedSiteResponse;
}
const $0d4b4afaa84d28bb$export$30ea0038b891f1cf = (baseUrl)=>({ cloudId: cloudId })=>$0d4b4afaa84d28bb$export$3273ac3481dc0616(cloudId, baseUrl);
module.exports["fetchProductRecommendationsWithCollaborators"] = $0d4b4afaa84d28bb$export$30ea0038b891f1cf;

});

parcelRegister("1Y265", function(module, exports) {
const $9486f2e1dfc1398c$var$appearanceMappedToConfluenceFlagType = (appearance)=>{
    switch(appearance){
        case 'normal':
        case 'success':
            return 'success-circle';
        default:
            return appearance;
    }
};
const $9486f2e1dfc1398c$export$90897e206b3c86f5 = (flags)=>(flag)=>{
        const { title: title, description: description, appearance: appearance, actions: actions } = flag;
        flags.showFlag({
            type: $9486f2e1dfc1398c$var$appearanceMappedToConfluenceFlagType(appearance),
            title: title,
            description: description,
            close: 'auto',
            actions: actions
        });
    };
module.exports["customShowFlag"] = $9486f2e1dfc1398c$export$90897e206b3c86f5;

});


//# sourceMappingURL=PageLayout.71145fed.js.map
